import React from 'react';

export const RevenueIntegrationSlots = () => {
  return (
    <>
      <slot name="revSchemaPicker" />
      <slot name="revNotifications" />
      <slot name="revLock" />
      <slot name="revPeriodSelector" />
      <slot name="revSettings" />
    </>
  );
};
